
import { SelectOption } from "../util";
import { defineComponent } from "vue";
import { mapState, mapGetters, mapActions } from "vuex";

type ComponentData = {
  professional_id?: number;
};
export default defineComponent({
  name: "NavSide",
  components: { SelectOption },
  data(): ComponentData {
    return { professional_id: undefined };
  },
  created() {
    this.populateProfessionalOptions();
  },
  computed: {
    ...mapGetters({
      six_weeks: "calendar/getSixWeeks",
      calendar_month: "calendar/getMonthOffset",
    }),
    ...mapState("calendar", ["period", "current_date"]),
    ...mapState("auth", ["current_user"]),
    ...mapState("agenda", ["professional_options"]),
  },
  methods: {
    ...mapActions({
      setMonth: "calendar/setOffsetMonth",
      populateProfessionalOptions: "agenda/populateProfessionalOptions",
      setProfessional: "agenda/setProfessional",
    }),
  },
  watch: {
    professional_id(id: number) {
      this.setProfessional(id);
    },
    "$store.state.agenda.professional_id"(id: number) {
      this.professional_id = id;
    },
  },
});
